import { cn } from "../../../lib/utils";

export function SkeletonText({
  className,
  lines = 1,
  width = "100%",
}: {
  className?: string;
  lines?: number;
  width?: string;
}) {
  return (
    <span className={cn("block space-y-2", className)}>
      {Array.from({ length: lines }).map((_, index) => (
        <span
          className="block h-3 animate-pulse rounded-full bg-muted motion-reduce:animate-none"
          key={index}
          style={{ width: index === lines - 1 ? width : "100%" }}
        />
      ))}
    </span>
  );
}
